module.exports = "<div class=\"col-md-12 padding-top20 padding-bottom20\">\n  <div class=\"row text-center\">\n    <h3>\n      privacy policy\n    </h3>\n  </div>\n  <div class=\"row\">\n      <div class=\"col-md-12 text-center padding-top20\">\n      </div>\n      <div class=\"col-md-12 text-center padding-top20\">\n        <button class=\"btn ss-btn-blue-wired\" (click)=\"closePoup()\">Close Modal</button>\n      </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reusable/confirm-privacy-modal/confirm-privacy-modal.component.html
// module id = ./src/app/shared/reusable/confirm-privacy-modal/confirm-privacy-modal.component.html
// module chunks = main